import React, { useState, useEffect, useContext } from 'react';
import { EditContext } from '@xingternal/pages-common';

import bookmarkIcon from './assets/bookmark.svg'; // eslint-disable-line
import bookmarkFillIcon from './assets/bookmark-fill.svg'; // eslint-disable-line

import styles from './JobsBookmark.css';

type JobsBookmarkProps = {
  trackingAction?: (isEditor: boolean, bookmarked: boolean) => void;
  initialBookmark: boolean;
  deleteBookmark?: () => void;
  createBookmark?: () => void;
  fixedValue?: boolean;
  error?: {
    showError: boolean;
    onError: () => void;
  };
  loading?: boolean;
};

const JobsBookmark: React.FC<JobsBookmarkProps> = ({
  trackingAction,
  initialBookmark,
  deleteBookmark,
  createBookmark,
  fixedValue = false,
  error,
  loading,
}) => {
  const [bookmarked, setBookmarked] = useState(initialBookmark);
  const { isEditor } = useContext(EditContext);

  const showError = error?.showError || false;
  const onError = error?.onError;

  const toggleBookmark = () => {
    if (bookmarked) {
      deleteBookmark && deleteBookmark();
    } else {
      createBookmark && createBookmark();
    }

    if (!fixedValue) {
      trackingAction && trackingAction(isEditor, !bookmarked);
      setBookmarked(!bookmarked);
    }
  };

  useEffect(() => {
    if (showError) {
      setBookmarked(!bookmarked);
      onError && onError();
    }
  }, [showError]);

  return (
    <button
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        if (!loading) {
          toggleBookmark();
        }
      }}
      className={styles.bookmarkButton}
      data-cy={'bookmark'}
      aria-label={bookmarked ? "Bookmark fill" : "Bookmark"}
    >
      <img
        src={bookmarked ? bookmarkFillIcon : bookmarkIcon}
        alt="Bookmark"
        className={styles.bookmark}
      />
    </button>
  );
};

export default JobsBookmark;
